import StudioModal from '@/components/modals/StudioModal.vue';
import { Component, Prop } from 'vue-property-decorator';
import { EModalName } from '@/helpers/modal';
import { Button, Checkbox } from 'streamlabs-beaker';
import EditorBase from '../editor/EditorBase';
import { EPlatformNames, EPlatformReadableNames } from '@/helpers/platforms';

@Component({
  components: {
    StudioModal,
    SButton: Button,
    SCheckbox: Checkbox,
  },
})
export default class EditPlatformModal extends EditorBase {
  @Prop({
    default: null,
    required: true,
  })
  selectedAccount;

  get modalName(): string {
    return EModalName.platform;
  }

  get accountTypeName(): string {
    if (!this.selectedAccount) {
      return EPlatformReadableNames.twitch;
    }

    switch (this.selectedAccount.type) {
      case EPlatformNames.twitch:
        return EPlatformReadableNames.twitch;

      case EPlatformNames.youtube:
        return EPlatformReadableNames.youtube;

      case EPlatformNames.kick:
        return EPlatformReadableNames.kick;

      case EPlatformNames.tiktok:
        return EPlatformReadableNames.tiktok;
    }

    return this.selectedAccount.type;
  }

  hideModal(modalName) {
    this.$modal.hide(modalName);
  }

  reauthenticate() {
    window.open(`/auth/${[this.selectedAccount.type]}?intent=reauth`, '_blank');
  }

  unlink() {
    this.$emit('unlink');
  }
}
